// Variables cho màn hình xác minh khủng bố
export interface IGetTerroristVerificationParams {
  page?: number;
  pageSize?: number;
  plantId?: string;
  terrorismType?: boolean | null; // true = An Toàn, false = Không An Toàn
  hasManagerApproval?: boolean; // true = Đã duyệt, false = Chưa duyệt
  userDateFrom?: string;
  userDateTo?: string;
}

export const TERRORIST_VERIFICATION_VARIABLES = {
  getList: (params: IGetTerroristVerificationParams) => {
    const {
      page,
      pageSize,
      plantId,
      terrorismType,
      hasManagerApproval,
      userDateFrom,
      userDateTo,
    } = params;
    return {
      input: {
        // Điều kiện bắt buộc: terrorism_user_approval IS NOT NULL
        terrorismUserApproval: { isNull: false },
        ...(plantId && {
          terrorismUserPlant: { equals: plantId },
        }),
        ...(terrorismType !== undefined &&
          terrorismType !== null && {
            terrorismType: { equals: terrorismType },
          }),
        ...(hasManagerApproval === true && {
          terrorismManagerApproval: { isNull: false },
        }),
        ...(hasManagerApproval === false && {
          terrorismManagerApproval: { isNull: true },
        }),
        ...(userDateFrom && { terrorismUserDate: { gte: userDateFrom } }),
        ...(userDateTo && { terrorismUserDate: { lte: userDateTo } }),
      },
      ...(page && { skip: (page - 1) * (pageSize ?? 10) }),
      ...(pageSize && { take: pageSize }),
    };
  },
};
